<template>
  <button
    class="category-button grid-x align-middle align-justify"
    :aria-expanded="stack.findIndex((i) => ['REGISTRY', 'REGISTRY'].indexOf(i.id) > -1) >= 0"
    data-flyout-id="registry"
    tabindex="0"
    @click="showSubCategories"
    @keydown.enter.prevent="handlePressEnter"
  >
    <span class="grid-x align-middle">
      <i v-if="isMcom" class="icon margin-right-xs registry-box"></i>
      <span class="category-text">{{ categoryText }}</span>
    </span>
    <i class="chevron-small-right-black chevron-small-right"></i>
  </button>
</template>

<script setup>
import { useMobileNav } from '~/composables/useMobileNav';
import focusAfterTransition from '~/utils/focusAfterTransition';

const envProps = useEnvProps();
const isMcom = envProps.isMcom;
const { stack, setMode, reset } = useMobileNav();
const categoryText = isMcom ? 'Gift Registry' : 'Registry';

function showSubCategories() {
  reset();
  const title = isMcom ? 'Gift Registry' : 'REGISTRY';
  const params = { id: 'registry', title, textTransform: false };
  setMode(params, true);
}

function handlePressEnter() {
  showSubCategories();
  focusAfterTransition({
    query: '.registry-info.transition-panel a',
    panelClass: '.transition-panel',
  });
}
</script>

<style lang="scss">
.category-button {
  cursor: pointer;
  width: 100%;
}
</style>

<style lang="scss" brand="bcom">
@import '~/assets/scss/mixins.bcom.scss';

.category-text {
  @include body(regular);
  color: inherit;
}
</style>
